export const breakpoints = {
  mobile: "320px",
  mobileMd: "375px",
  mobileLg: "480px",
  tablet: "768px",
  desktop: "1400px",
  large: "1440px",
  widescreen: "1920px"
};

export const device = {
  mobile: `(min-width: ${breakpoints.mobile})`,
  mobileMd: `(min-width: ${breakpoints.mobileMd})`,
  mobileLg: `(min-width: ${breakpoints.mobileLg})`,
  tablet: `(min-width: ${breakpoints.tablet})`,
  desktop: `(min-width: ${breakpoints.desktop})`,
  large: `(min-width: ${breakpoints.large})`,
  widescreen: `(min-width: ${breakpoints.widescreen})`
};
